import React, { useEffect, useState } from "react";
import { getNewsData, TrendingTodayData } from "../../../Services/service";
import block1 from "../../../assets/images/News/block1.jpg";
import block2 from "../../../assets/images/News/block2.jpeg";
import block3 from "../../../assets/images/News/block3.jpeg";
import icon4 from "../../../assets/images/icon/icon-4.png";
import postbar from "../../../assets/images/icon/post-bars.png";
import latestp1 from "../../../assets/images/News/latest-post-11.jpeg";
import latestp2 from "../../../assets/images/News/latest-post-12.jpeg";
import latestp3 from "../../../assets/images/News/latest-post-13.jpeg";
import newyear from "../../../assets/images/News/newyear.jpeg";
import { useParams , useNavigate} from "react-router-dom";
import ShareButton from "../../ShareButton/ShareButton";
import PostCardStyleOne from "../../../containers/HomeOne/PostCards/PostCardStyleOne";

function AuthorSection() {
    const [feedData, setFeedData] = useState();
const [todayTrending, setTodayTrending] = useState([]);
    const {id} = useParams();
    const navigate = useNavigate();

  useEffect(() => {
      loadData();
      window.scrollTo(0, 0);
    }, [id]);
  
    async function loadData() {
      const data = await getNewsData(id);
      setFeedData(data.feedinfo[id]);   
    }

  useEffect(() => {
    loadData2();
  }, []);

  async function loadData2() {
    const Tdata = await TrendingTodayData();
    setTodayTrending(Tdata); 
  }
    return (
      <div className="news-main-container">
        {feedData ? (
          <div className="newscontainer">
            <h2>{feedData.title}</h2>
            {/* Display Images if Available */}
            {feedData.images && feedData.images.length > 0 && (
              <div>
                {feedData.images.map((img, index) => (
                  <img key={index} src={img} alt={`Image ${index + 1}`} style={{ width: "100%", height:"auto", margin: "5px" }} />
                ))}
              </div>
            )}
            <div className="data-opt" style={{display:"flex",gap:"20px",marginTop:"10px"}}>
            <p><strong>Author:</strong> {feedData.author}</p>
            <p><strong>Date:</strong> {feedData.date}</p>
            <p><strong>Views:</strong> {feedData.view}</p>
            <div className="share">
              <ShareButton open={feedData.id}/>
            </div>
            </div>
            {/* Display Content */}
            <div className="newsdata">
              {feedData.content && feedData.content.map((item, index) => (
                <div key={index}>
                <img src={item.images} style={{ width:"100%", height:"auto"}} />
                <p >{item.data}
                </p>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>Loading...</p>
        )}
        <div className="row">
                    {Array.isArray(todayTrending.TodaysData) ?(
                    todayTrending.TodaysData.map((Item, index) => (
                        <div key={Item.id || index} className="col-lg-3 col-md-6">
                          <div className="binduz-er-trending-today-item">
                          <PostCardStyleOne
                              datas={{
                                image: Item.images,
                                category: Item.news,
                                date: Item.date,
                                title: Item.title,
                                id: Item.id,
                                video:Item.video,
                              }}
                            />
                          </div>
                        </div>
                      ))):(<h1>Not Found</h1>) } 
                  </div>
      </div>
    );

}

export default AuthorSection;
